module.exports = __webpack_public_path__ + "static/akinbo-e4da25b3129281ed3eadefe85947959d.jpg";